import {DATETIME_INPUT_TIME_PICKER_FORMAT_MAP} from './const';

/**
 * Extracts time picker format keys and values from a datetime format string
 * 
 * @param {string} datetimeFormat - The datetime format string (e.g., 'YYYY-MM-DD HH:mm:ss')
 * @returns {Array} Array of objects containing key and value properties for matching time picker formats found in the format string
 */
export const getTimePickerFormatFromDatetimeFormat = (datetimeFormat) => {
	if (!datetimeFormat || typeof datetimeFormat !== 'string') {
		return [];
	}

	const result = [];
	const matchedPositions = new Set();

	// Use keys in the order they are defined in the const
	const keys = Object.keys(DATETIME_INPUT_TIME_PICKER_FORMAT_MAP);

	// Find all matches in the format string
	keys.forEach(key => {
		let startIndex = 0;
		while (startIndex < datetimeFormat.length) {
			const index = datetimeFormat.indexOf(key, startIndex);
			if (index === -1) break;

			// Check if this position hasn't been matched yet
			const isPositionMatched = Array.from({length: key.length}, (_, i) => index + i)
				.some(pos => matchedPositions.has(pos));

			if (!isPositionMatched) {
				// Mark all positions of this key as matched
				for (let i = 0; i < key.length; i++) {
					matchedPositions.add(index + i);
				}
				result.push({
					index,
					key,
					value: DATETIME_INPUT_TIME_PICKER_FORMAT_MAP[key]
				});
			}

			startIndex = index + 1;
		}
	});

	// Sort by index and return objects with key and value
	return result.sort((a, b) => a.index - b.index).map(item => ({key: item.key, value: item.value}));
};

